
// 智慧报修
import Log from '../view/log'
import repairOverView from '../view/RepairManagement/repairOverView/repairOverView'
import repairCategoryManage from '../view/RepairManagement/repairCategory/repairCategoryManage'
import repairCategoryAdd from '../view/RepairManagement/repairCategory/repairCategoryAdd'
import repairCategoryModify from '../view/RepairManagement/repairCategory/repairCategoryModify'
import repairRecord from '../view/RepairManagement/repairRecord/repairRecord'
import repairRecordCurrent from '../view/RepairManagement/repairRecord/repairRecordCurrent'
import repairPayRecord from '../view/RepairManagement/repairPayRecord/repairPayRecord'
import repairPersonManage from '../view/RepairManagement/repairPerson/repairPersonManage'
import repairPersonAdd from '../view/RepairManagement/repairPerson/repairPersonAdd'
import repairPersonModify from '../view/RepairManagement/repairPerson/repairPersonModify'
import repairManageNav from '../view/RepairManagement/repairManageNav'

export default [
  /* 智慧报修 */
  {
    path: '/repair_over_view',
    name: 'repair-over-view',
    components: {
      default: repairManageNav,
      a: repairOverView
    }
  },
  {
    path: '/repair_category_manage',
    name: 'repair-category-manage',
    components: {
      default: repairManageNav,
      a: repairCategoryManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/repair_category_add',
    name: 'repair-category-add',
    components: {
      default: repairManageNav,
      a: repairCategoryAdd
    }
  },
  {
    path: '/repair_category_modify',
    name: 'repair-category-modify',
    components: {
      default: repairManageNav,
      a: repairCategoryModify
    }
  },
  {
    path: '/repair_record',
    name: 'repair-record',
    components: {
      default: repairManageNav,
      a: repairRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/repair_record_current/:id',
    name: 'repair-record-current',
    components: {
      default: repairManageNav,
      a: repairRecordCurrent
    }
  },
  {
    path: '/repair_pay_record',
    name: 'repair-pay-record',
    components: {
      default: repairManageNav,
      a: repairPayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/repair_person_manage',
    name: 'repair-person-manage',
    components: {
      default: repairManageNav,
      a: repairPersonManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/repair_person_add',
    name: 'repair-person-add',
    components: {
      default: repairManageNav,
      a: repairPersonAdd
    }
  },
  {
    path: '/repair_person_modify',
    name: 'repair-person-modify',
    components: {
      default: repairManageNav,
      a: repairPersonModify
    }
  },
  /* 智慧报修 */
  // 智慧报修操作日志
  {
    path: '/repair_manage_log',
    name: 'repair-manage-log',
    components: {
      default: repairManageNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/RepairManagement.js